<script setup>
import { computed } from 'vue';
import BreezeButton from '@/Components/Button.vue';
import Layout from '@/Layouts/Layout.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import FormHeader from '@/Components/FormHeader.vue';

const props = defineProps({
    status: String,
});

const form = useForm();

const submit = () => {
    form.post(route('verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
    <LayoutNew> 
        <div style="max-width: 450px; width: 100%;">            
            <FormHeader v-bind:title="__('Weryfikacja adresu e-mail')"/>
            
            <p class="mb-2 alert alert-secondary" v-text="__('Dziękujemy za zapisanie się! Zanim zaczniesz, prosimy o zweryfikowanie adresu e-mail, klikając na link, który właśnie do Ciebie wysłaliśmy. Jeśli nie otrzymałeś wiadomości na twój e-mail, chętnie wyślemy Ci inną.')"/>
            <div class="text-center text-sm alert alert-info" v-if="verificationLinkSent" v-text="__('Nowy link weryfikacyjny został wysłany na adres e-mail podany podczas rejestracji.')"/>
            <div class="mt-3">
                <form @submit.prevent="submit">                    
                    <BreezeButton :class="{ 'opacity-25': form.processing, 'btn': true, 'btn-primary': true, 'w-100': true, 'p-3': true }" :disabled="form.processing" v-text="__( 'Wyślij e-mail weryfikacyjny' )"/>
                </form>
            </div>
            
        </div>
    
    </LayoutNew>
</template>
